import CryptoJS from "crypto-js";
import { useNavigate } from "react-router-dom";
import ChevronRight from "../../assets/images/chevron_right-gray.svg";
import useLanguageTranslate from "../../hooks/useLanguageTranslate";
import { resolveClaimStage } from "../motorInsurancePages/trackClaimFlow/claimComponents/claimStatus";

const ActiveClaimCard = ({ claim }) => {
  const navigate = useNavigate();
  const valueToEncrypt = claim.CaseNumber;
  const translate = useLanguageTranslate();
  // Encryption logic
  const secretKey = "i-hate-meej";
  const encryptedValue = CryptoJS.AES.encrypt(
    valueToEncrypt,
    secretKey
  ).toString();

  // Convert to URL-safe format
  const urlSafeEncryptedValue = encryptedValue
    .split("+")
    .join("-") // Replace '+' with '-'
    .split("/")
    .join("_") // Replace '/' with '_'
    .split("=")
    .join(""); // Remove '=' padding

  // Shared with the claim details page, so both screens bucket a CRM status the
  // same way and colour it the same way. `stage.key` is the untranslated stage
  // name because it doubles as the CSS class that colours the pill — this used
  // to be built from the translated label, so in Arabic the class was "الإبلاغ",
  // matched no rule in index.css, and the pill rendered white text on nothing.
  const stage = resolveClaimStage(claim.Status);
  const claimStatus = translate(stage.label_en, stage.label_ar);

  return (
    <div
      // onClick={() =>
      //   navigate("/motor-insurance/claim-details/" + claim.CaseNumber, {
      //     state: { key1: claimStatus, key2: claim.IntimationDateStr },
      //   })
      // }
      onClick={() =>
        navigate(`/motor-insurance/claim-details/${urlSafeEncryptedValue}`)
      }
      className="flex items-center gap-4 shrink-0 border bg-[#F6F8F9] p-4 rounded-2xl border-solid border-[#DDE2E4] max767:w-full cursor-pointer max767:mb-4 justify-between"
    >
      <div className="flex flex-col gap-2">
        <p
          className={`claim-item text-white text-center text-xs not-italic font-semibold leading-4 tracking-[0.12px] uppercase h-5 justify-end items-center gap-4 px-2 py-0 rounded-[10px] text-left ${
            stage.key || "bg-[#84919a]"
          }`}
        >
          {claimStatus}
        </p>
        <h1 className="text-[#48535B] text-xl not-italic font-semibold leading-[normal] max767:text-2xl">
          {claim.CaseNumber}
        </h1>
        <div className="flex items-center gap-1">
          <p className="text-[#48535B] text-sm not-italic font-normal leading-[normal]">
            {claim.IntimationDateStr}
          </p>
        </div>
      </div>
      <img
        src={ChevronRight}
        alt="ChevronRight"
        className="cursor-pointer rtl:rotate-180"
      />
    </div>

    // <div className="flex w-60 flex-col items-start gap-4 shrink-0 border bg-[#F6F8F9] p-4 rounded-2xl border-solid border-[#DDE2E4] max767:w-full max767:mb-4">
    //   <p className={`claim-item ${claim.status}`}> {claim.status}</p>
    //   <div className="flex flex-col items-start gap-1 self-stretch">
    //     <p className="text-[#48535B] text-xs not-italic font-semibold leading-[normal]">
    //       {claim.carMakeModel}
    //     </p>

    //     <h1 className="text-[#48535B] text-xl not-italic font-semibold leading-[normal] max767:text-2xl">
    //       {claim.plateNumber}
    //     </h1>
    //   </div>
    //   <div className="flex flex-col items-start gap-1 self-stretch">
    //     <p className="text-[#48535B] text-sm not-italic font-normal leading-[normal]">
    //       {" "}
    //       {claim.policyNumber}
    //     </p>
    //     <p className="text-[#48535B] text-xs not-italic font-normal leading-[normal]">
    //       {claim.claimDate}
    //     </p>
    //   </div>
    // </div>
  );
};

export default ActiveClaimCard;
